import { useState, useEffect } from "react";
import styles from "./style.module.scss";
import PitchIcon from "assets/icons/pitch-counter.svg";
import PitchIcon2 from "assets/icons/pitch-counter-2.svg";
import NotificatonIcon from "assets/icons/notification.svg";
import PromotionIcon from "assets/icons/promotion.svg";
import axios from "axios";
import { useKeycloak } from "@react-keycloak/web";
import LoaderSpinner from "../../UI/LoaderSpinner/LoaderSpinner";
import { AnnouncementModelResponse } from "types";
import { locationController } from "utils/locationhelper";
import AuthService from "services/AuthService";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify'

const DashboardInfoBox = () => {

  const { keycloak } = useKeycloak();
  const [sayacCount,setInstallations] = useState(0);
  const [announcementCount,setAnnouncementCount] = useState(0); 
  const [isLoading, setIsLoading] = useState(false);

  const auth = new AuthService(keycloak);

  let companyId = locationController();
 

  useEffect(() => {
    getInstallations()
  }, []);

  const getInstallations = async() => {
    setIsLoading(true);

    let instRequest = `/InstallationOperations/GetInstallationInfo`

    let announceRequest=`/Announcement/GetAnnouncementList`

    const requestOne = auth.axios(instRequest, null, {
      email: keycloak?.tokenParsed?.email,
      companyId : companyId,
      pageSize: 25,
      page: 1
    });
    const requestTwo = auth.axios(announceRequest, null);

    axios
   .all([requestOne, requestTwo])
    .then(
    axios.spread((...responses) => {
      setIsLoading(false);
      const responseOne = responses[0];
      const responseTwo = responses[1];
      
      if (responseOne.data.success === true) {
        setInstallations(responseOne.data.totalCount);
      }

      else{
        if(responseOne.data.message){
          toast.error(responseOne.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored"
         });
        }
      }

      if (responseTwo.data.success === true) {
        setAnnouncementCount(responseTwo.data.data.totalCount);
      }

      else{
        if(responseTwo.data.message){
          toast.error(responseTwo.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored"
         });
        }
      }
      
    })
     )
    .catch(errors => {
    setIsLoading(false);
    });
  }


  return (
   <div>
    <ToastContainer/>
    <div className={styles.infoBox}>
      <div className={styles.boxOrange}>
        <div className={styles.boxLeft}>
          <img src={PitchIcon} alt="" />
          <div>Tesisat Sayısı</div>
        </div>
        <div className={styles.boxRight}>{sayacCount}</div>
        <img src={PitchIcon2} className={styles.icon}></img>
      </div>
      <div className={styles.boxBlue}>
        <div className={styles.boxLeft}>
          <img src={NotificatonIcon} alt="" />
          <div>Duyurular</div>
        </div>
        <div className={styles.boxRight}>{announcementCount}</div>
        <img src={PromotionIcon} className={styles.icon}></img>
      </div>
      {isLoading ? <LoaderSpinner /> : ""}
    </div>
  </div>
  );
};

export default DashboardInfoBox;
